{
  "seo": {
    "title": {
      "zh": "Asura 泰國菜｜香港泰式沾麵、家常菜與分店",
      "en": "Asura Thai Hong Kong | Dipping Noodles & Home Cooking"
    },
    "description": {
      "zh": "Asura 在香港呈現泰國家常菜，從一碗兩醬的招牌泰式沾麵到金邊粉與共享小菜。查看尖東、啟德及銅鑼灣分店地址、聯絡方式與 Instagram 最新動態。",
      "en": "Explore Thai home cooking in Hong Kong at Asura: signature dipping noodles with two curry sauces, pad Thai and sharing dishes. Find our Tsim Sha Tsui, Kai Tak and Causeway Bay locations, contacts and Instagram updates."
    },
    "url": "https://asurathai.com/",
    "image": "https://asurathai.com/images/hero.jpg"
  },
  "brand": {
    "name": "ASURA",
    "descriptor": "THAI HOME COOKING",
    "sigil": "A",
    "logo": "/brand/asura-logo.svg",
    "pattern": "/brand/asura-pattern.svg",
    "ariaLabel": {
      "zh": "Asura Thai 首頁",
      "en": "Asura Thai home"
    }
  },
  "interface": {
    "skip": { "zh": "跳到主要內容", "en": "Skip to content" },
    "language": { "zh": "EN", "en": "中" },
    "more": { "zh": "了解更多", "en": "Discover more" },
    "dialogClose": { "zh": "關閉內容", "en": "Close story" },
    "primaryNavigation": { "zh": "主要導覽", "en": "Primary navigation" },
    "secondaryNavigation": { "zh": "次要導覽", "en": "Secondary navigation" },
    "mobileNavigation": { "zh": "手機導覽", "en": "Mobile navigation" },
    "carouselLabel": { "zh": "Asura 招牌菜式橫向展示", "en": "Asura signature dishes carousel" },
    "carouselHint": { "zh": "左右滑動瀏覽招牌菜式", "en": "Swipe or scroll to explore signature dishes" },
    "switchLanguage": { "zh": "Switch to English", "en": "切換至中文" },
    "mobileLanguage": { "zh": "English", "en": "繁體中文" }
  },
  "navigation": [
    { "id": "philosophy", "label": { "zh": "品牌故事", "en": "Our story" } },
    { "id": "menu", "label": { "zh": "招牌菜式", "en": "Signatures" } },
    { "id": "team", "label": { "zh": "泰式風味", "en": "Flavours" } },
    { "id": "visit", "label": { "zh": "聯絡我們", "en": "Contact us" } }
  ],
  "hero": {
    "image": "/images/hero.webp",
    "alt": {
      "zh": "炭烤虎蝦、泰式青咖喱與新鮮香草鋪滿深色餐桌",
      "en": "Charcoal-grilled tiger prawns, green curry and fresh herbs on a dark dining table"
    },
    "title": { "zh": "泰國家常味", "en": "Thai home cooking" },
    "subtitle": {
      "zh": "Asura 在香港呈現泰國家常菜：招牌泰式沾麵、咖喱、炒粉麵與適合共享的小菜。",
      "en": "Asura serves Thai home cooking in Hong Kong, from signature dipping noodles and curries to wok-fired noodles and sharing plates."
    },
    "cta": { "zh": "分店", "en": "Locations" },
    "ctaHref": "#visit"
  },
  "philosophy": {
    "title": { "zh": "泰國家常菜", "en": "Thai home cooking" },
    "paragraphs": [
      {
        "zh": "Asura 以泰國家常菜為核心，將泰國家庭日常享用的冬陰功、咖喱與分享小菜帶到香港。菜式適合親友圍坐一桌，慢慢品嚐，一同分享。",
        "en": "Asura brings Thai home cooking to Hong Kong through familiar dishes such as tom yum, curries and sharing plates. The menu is made for friends and family to gather around one table."
      },
      {
        "zh": "在 Phaya Asura 泰公館，菜式、泰國食材、器皿與空間細節，共同呈現泰國的日常生活。店主 Ken 親赴泰國挑選碗碟及部分小型餐具，將對細節的用心帶到餐桌，讓客人感受泰國家常用餐的溫暖。",
        "en": "At Phaya Asura, everyday Thai life inspires the dishes, ingredients, tableware and space. Owner Ken personally selects bowls, plates and smaller pieces in Thailand, bringing care and the warmth of a Thai family meal to every table."
      }
    ],
    "images": [
      {
        "image": "/images/shared-table.webp",
        "alt": { "zh": "泰國家常菜圍桌分享的餐桌", "en": "A table of Thai home-style dishes made for sharing" }
      },
      {
        "image": "/images/hospitality.webp",
        "alt": { "zh": "Asura 泰式家常用餐空間與餐桌細節", "en": "Asura dining room and table details inspired by Thai home dining" }
      }
    ]
  },
  "menu": {
    "title": { "zh": "招牌菜式", "en": "Signature dishes" },
    "intro": {
      "zh": "Asura 的招牌泰式沾麵以米線配青咖喱雞湯與紅咖喱虎蝦湯，另有大蝦金邊粉、鑊氣炒河及泰式小菜。菜式供應以分店即日餐牌為準。",
      "en": "Asura's signature Thai dipping noodles pair rice noodles with green curry chicken and red curry tiger prawn sauces. The menu also includes prawn pad Thai, wok-fired noodles and Thai small plates. Availability follows each location's daily menu."
    },
    "items": [
      {
        "name": { "zh": "招牌泰式沾麵", "en": "Signature Thai dipping noodles" },
        "description": { "zh": "泰國米線、酸菜、芽菜、炸雞蛋，配青咖喱雞湯及紅咖喱虎蝦湯", "en": "Thai rice noodles, pickled vegetables, bean sprouts and fried egg with two curry dipping sauces" },
        "price": "",
        "image": "/images/signature-dipping-noodles.webp",
        "alt": { "zh": "泰國米線配炸蛋、酸菜、芽菜及兩款咖喱沾醬", "en": "Thai rice noodles with fried egg, pickled vegetables, bean sprouts and two curry dipping sauces" }
      },
      {
        "name": { "zh": "大蝦炒金邊粉", "en": "Prawn pad Thai" },
        "description": { "zh": "大蝦、羅望子、花生與鑊氣米粉", "en": "Prawns, tamarind, peanut and wok-fired rice noodles" },
        "price": "",
        "image": "/images/pad-thai.webp",
        "alt": { "zh": "鑊炒大蝦金邊粉", "en": "Wok-fired prawn pad Thai" }
      },
      {
        "name": { "zh": "雞肉鑊氣炒河", "en": "Wok-fired chicken rice noodles" },
        "description": { "zh": "雞肉、闊河粉、蔬菜與鑊氣豉油香", "en": "Chicken, wide rice noodles, vegetables and smoky soy" },
        "price": "",
        "image": "/images/thai-curry.webp",
        "alt": { "zh": "泰式鑊炒雞肉河粉", "en": "Thai wok-fired chicken rice noodles" }
      },
      {
        "name": { "zh": "炸魚露漬豬頸肉", "en": "Fish-sauce marinated pork neck" },
        "description": { "zh": "香脆豬頸肉與泰式魚露香氣", "en": "Crisp pork neck with fragrant Thai fish sauce" },
        "price": "",
        "image": "/images/shared-table.webp",
        "alt": { "zh": "泰式共享菜式餐桌", "en": "A table of Thai sharing dishes" }
      }
    ]
  },
  "reservations": {
    "title": { "zh": "分店位置", "en": "Our locations" }
  },
  "team": {
    "title": { "zh": "泰式風味", "en": "Thai flavours" },
    "intro": {
      "zh": "Asura 的泰式風味從一碗兩醬沾麵開始：青咖喱雞與紅咖喱虎蝦各有香辣層次。鑊氣炒粉麵、船麵與家常小菜則適合一桌分享。",
      "en": "Asura's Thai flavours begin with dipping noodles and two curry sauces: green curry chicken and red curry tiger prawn. Wok-fired noodles, boat noodles and home-style small plates complete a table made for sharing."
    },
    "members": [
      {
        "name": { "zh": "雙醬沾麵", "en": "Two curry sauces" },
        "role": { "zh": "青咖喱雞 / 紅咖喱虎蝦", "en": "Green curry chicken / red curry tiger prawn" },
        "bio": {
          "zh": "泰國米線分別蘸上青咖喱雞湯與紅咖喱虎蝦湯，咖喱掛滿米線，帶來兩種截然不同的香辣層次。",
          "en": "Dip Thai rice noodles into green curry chicken and red curry tiger prawn sauces for two distinct layers of aromatic heat."
        },
        "image": "/images/chef.webp",
        "alt": { "zh": "廚師在出菜前完成泰式菜式", "en": "A chef finishing a Thai dish before service" }
      },
      {
        "name": { "zh": "地道小食", "en": "Thai small plates" },
        "role": { "zh": "炒粉麵 / 船麵 / 燒物", "en": "Noodles / boat noodles / grilled dishes" },
        "bio": {
          "zh": "餐牌包括雞肉鑊氣炒河、正宗船麵、炸魚露漬豬頸肉與飛天炒通菜，呈現泰國街頭與餐桌的熱鬧風味。",
          "en": "The menu extends to wok-fired chicken noodles, boat noodles, fish-sauce pork neck and morning glory, bringing lively Thai street and table flavours together."
        },
        "image": "/images/hospitality.webp",
        "alt": { "zh": "Asura 團隊在服務前準備餐桌", "en": "The Asura team preparing the dining room before service" }
      }
    ]
  },
  "contact": {
    "title": { "zh": "聯絡我們", "en": "Contact us" },
    "columns": [
      {
        "title": { "zh": "尖東・半島中心", "en": "Peninsula Centre" },
        "lines": [
          { "zh": "2155 9912・WhatsApp 5644 4463", "en": "2155 9912 · WhatsApp 5644 4463" },
          { "zh": "尖沙咀麼地道67號半島中心地下G37-38號舖", "en": "Shops G37-38, G/F, Peninsula Centre, 67 Mody Road, Tsim Sha Tsui" },
          { "zh": "每日 12:00-16:00 / 18:00-22:30", "en": "Daily 12:00-16:00 / 18:00-22:30" }
        ],
        "href": "tel:+85221559912"
      },
      {
        "title": { "zh": "啟德・AIRSIDE", "en": "Kai Tak · AIRSIDE" },
        "lines": [
          { "zh": "WhatsApp 9164 8400", "en": "WhatsApp 9164 8400" },
          { "zh": "九龍啟德協調道2號AIRSIDE 2樓L205號舖", "en": "Shop L205, 2/F, AIRSIDE, 2 Concorde Road, Kai Tak" },
          { "zh": "每日 12:00-22:00（以 AIRSIDE 最新公布為準）", "en": "Daily 12:00-22:00 (check AIRSIDE for the latest hours)" }
        ],
        "href": "https://wa.me/85291648400"
      },
      {
        "title": { "zh": "Asuri・希慎廣場", "en": "Asuri · Hysan Place" },
        "lines": [
          { "zh": "希慎廣場 B2/F URBANHOOD B207號舖", "en": "Shop B207, B2/F, URBANHOOD, Hysan Place" },
          { "zh": "銅鑼灣軒尼詩道500號希慎廣場", "en": "Hysan Place, 500 Hennessy Road, Causeway Bay" },
          { "zh": "每日 11:30-21:30", "en": "Daily 11:30-21:30" }
        ],
        "href": "https://www.instagram.com/asura_thai/"
      },
      {
        "title": { "zh": "啟德・泰公館", "en": "Kai Tak · Phaya Asura" },
        "lines": [
          { "zh": "訂座 3628 3616", "en": "Reservations 3628 3616" },
          { "zh": "啟德承啟道38-39號啟德體育園美食海灣地下DC-005號舖", "en": "Shop DC-005, G/F, Dining Cove, Kai Tak Sports Park, 38-39 Shing Kai Road, Kai Tak" },
          { "zh": "營業安排請向分店確認", "en": "Please confirm current opening hours with the restaurant" }
        ],
        "href": "tel:+85236283616"
      }
    ],
    "social": [
      { "label": "Instagram", "href": "https://www.instagram.com/asura_thai/" },
      { "label": "Facebook", "href": "https://www.facebook.com/thai.asura/" }
    ],
    "legal": {
      "zh": "Asura 泰沾麵、Asuri 及泰公館。地址及聯絡資料參考 AIRSIDE、啟德體育園、OpenRice 與官方 Instagram；營業時間或會調整。",
      "en": "Asura Thai Dipping Noodles, Asuri and Phaya Asura. Addresses and contacts reference AIRSIDE, Kai Tak Sports Park, OpenRice and official Instagram profiles; opening hours may change."
    }
  }
}
